<template>
  <div class="bm-create-team" >
    <div class="title" >创建球队</div>
    <p>创建球队自动成为参赛球队，如需编辑球队/球员信息请前往参赛球队设置</p>
    <van-row class="form" type="flex" justify="space-between" >
      <van-col span="16">
        <van-cell-group>
          <van-field v-model="name" placeholder="请输入球队名称" />
        </van-cell-group>
      </van-col>
      <van-col span="6">
        <div class="btn" >
          <van-icon size="20px" color="#fff" name="cross" @click="submitAction" />
        </div>
      </van-col>
    </van-row>
    <div style="width: 100%; height: 20px;" ></div>
    <div class="team" v-for="(item, index) in teamList" :key="item.teamId">
      <div>
        <img class="icon" src="@/assets/images/team-logo-empty.png" alt="">
      </div>
      <div>
        <p>{{item.name}}</p>
        <span>待认领</span>
      </div>
      <div v-show="isShowGroup" :class="{'groupAction': !item.groupName}" @click="openGroupAction(index)">
        <span :class="{'active': item.groupName}">{{item.groupName? item.groupName:'分组'}}</span>
      </div>
    </div>
    <div class="foot" @click="goTeamList">
       完成
    </div>

    <!-- group start-->
    <van-popup v-model="isShowPopup" position="bottom" >
      <van-picker show-toolbar :columns="groups" value-key="name"
                  @cancel="onCancel"
                  @confirm="onConfirm" />
    </van-popup>
    <!-- end -->
    <!-- group length 0 start-->
    <van-popup v-model="isShowNotice" position="bottom" >
      <div class="pop-action">
        <div class="action-btn" @click="onPopCancel">取消</div>
        <div class="action-btn" @click="onPopConfirm">确认</div>
      </div>
      <div class="group-notice">
        <div>还没设置组数</div>
        <div>请前往赛事规则-比赛赛制页设置组数</div>
      </div>
    </van-popup>
    <!-- end -->
  </div>
</template>

<script>
import Vue from 'vue'
import { getBMMatchTeams, createBMMatchTeamInfo, updateBMMatchTeamInfo } from '@/api/team'

import { Icon, Toast } from 'vant'
Vue.use(Icon).use(Toast)

export default {
  data() {
    return {
      name: '',
      query: this.$route.query,
      isShowPopup: false,
      teamList: [],
      groups: [],
      isShowGroup: false,
      isShowNotice: false,
      currentTeam: {},
      selectedGroup: {}
    }
  },
  computed: {

  },
  created() {
    this.getBMMatchTeams()
  },
  methods: {
    getBMMatchTeams: function () {
      const params = {
        matchId: this.query.matchId
      }
      getBMMatchTeams(params).then(response => {
        const data = response.data
        if (data.match && data.match.groups) {
          this.isShowGroup = true
          this.groups = data.match && data.match.groups
        } else {
          this.isShowGroup = false
        }
      })
    },
    submitAction: function () {
      if (this.name) {
        this.createBMMatchTeamInfo()
      } else {
        Toast('请输入球队名称')
      }
    },
    createBMMatchTeamInfo: function () {
      const params = {
        matchId: this.query.matchId,
        name: this.name
      }
      createBMMatchTeamInfo(params).then(response => {
        const data = response.data
        if (data && data.team) {
          this.teamList.push(data.team)
        }
        this.name = ''
      })
    },
    updateBMMatchTeamInfo: function () {
      const params = {
        matchId: this.query.matchId,
        groupId: this.selectedGroup.id,
        teamId: this.currentTeam.id
      }
      updateBMMatchTeamInfo(params).then(response => {
        const data = response.data
        if (data && data.update) {
          this.currentTeam.groupName = this.selectedGroup.name
          this.isShowPopup = false
        }
      })
    },
    goTeamList: function () {
      this.$router.push({ name: 'TeamList', query: {matchId: this.query.matchId} })
    },
    openGroupAction: function (index) {
      this.currentTeam = this.teamList[index]
      if (this.groups.length > 0) {
        this.isShowPopup = true
      } else {
        this.isShowNotice = true
      }
    },
    onCancel: function () {
      this.isShowPopup = false
    },
    onConfirm: function (value, index) {
      this.selectedGroup = value
      this.updateBMMatchTeamInfo()
    },
    onPopCancel: function () {
      this.isShowNotice = false
    },
    onPopConfirm: function (value, index) {
      this.isShowNotice = false
    }
  }
}
</script>

<style lang="stylus">
  .bm-create-team
    background-color: white
    width 100%
    height: 100%
    position absolute
    .title
      font-size: 30px;
      font-weight: 400;
      color: rgba(0,0,0,1);
      padding: 10px 15px;
    .title+p
      font-size:16px;
      font-weight:300;
      color:rgba(0,0,0,1);
      line-height:22px;
      padding: 0 15px 15px;
      margin: 0;
    .form
      padding: 0 15px;
    .btn
      width 40px
      height: 40px
      text-align center
      line-height 40px
      background:rgba(50,163,119,1);
      border-radius:2px;
      float right
      font-size: 30px
      color: white
      .van-icon
        transform rotate(45deg);
    .team
      display flex
      padding 15px
      .icon
        width: 52px
      div:first-child
        width 52px
        height 52px
        margin-right: 10px
        background-color #cccccc
      div:nth-child(2)
        display flex
        flex-direction column
        justify-content: space-between;
        width: calc(100% - 112px)
        p
          margin: 0;
          font-size:14px;
          font-weight:400;
          color:rgba(0,0,0,1);
        span
          font-size:12px;
          font-weight:400;
          color:rgba(129,129,129,1);
      div:last-child
        width: 50px
        span
          text-align center
          border:1px solid rgba(242,242,242,1);
          font-size: 12px;
          font-weight: 400;
          color: rgba(155,155,155,1);
          height 40px
          width: 40px
          line-height 40px
          display block
    .active
      color: #000 !important;
      font-size: 16px !important
    .foot
      padding: 10px 0
      background: rgba(250,250,250,1);
      text-align center
      position fixed
      bottom: 0
      width: 100%
      font-size:20px;
      font-weight:400;
      color:rgba(50,163,119,1);
      max-width: 480px;
    .group-notice
      color: #9b9b9b;
      font-size: 14px
      min-height: 135px;
      text-align: center;
      padding-top: 24px;
  .pop-action
      display: flex;
      height: 44px;
      line-height: 44px;
      -webkit-box-pack: justify;
      justify-content: space-between
      .action-btn
        color: #9b9b9b;
        padding: 0 15px;
        font-size: 14px;
</style>



// WEBPACK FOOTER //
// src/pages/create/index.vue